import React, { useEffect, useState } from "react";
import Layout from "../../../common/layout";
import { useTranslation } from "react-i18next";
import { MenuGroup, MenuGroupItem, Heading, MenuItem, MenuBox } from "./styles";
import { GetIcon } from "../../../../../icons";
import PopupView from "../../../../elements/popupview";
import Switch from "../../../../router/switch";
import { useDispatch, useSelector } from "react-redux";
import { clearLogin } from "../../../../../store/actions/login";
import AutoForm from "../../../../elements/form";
import i18n from "i18next"; // i18n library for internationalization
import { postData } from "../../../../../backend/api";
import { Title } from "../../../common/layout/header/styels";
import { RowContainer } from "../../../../styles/containers/styles";
import { useNavigate } from "react-router-dom";
const Report = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${t("settings")} - PersoBase`;
  }, [t]);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [openData, setOpenData] = useState(null);
  const themeColors = useSelector((state) => state.themeColors);
  const selectedMenu = useSelector((state) => state.selectedMenu);
  const [selectedLanguage, setSelectedLanguage] = useState(
    // If a language is stored in local storage, use it, otherwise use "de"
    localStorage.getItem("_lang") !== null ? localStorage.getItem("_lang") : "de"
  );
  const navigation = useNavigate()
  const dispatch = useDispatch();
  const handleLanguageChange = (language) => {
    // Change the language in the i18n library
    if (selectedLanguage === "en") {
      i18n.changeLanguage("de");
      setSelectedLanguage("de");
      localStorage.setItem("_lang", "de");
    } else {
      i18n.changeLanguage("en");
      setSelectedLanguage("en");
      localStorage.setItem("_lang", "en");
    }
  };
  const [showResetPassword, setShowResetPassword] = useState(false);
  const isCreatingHandler = (value, callback) => {
    setShowResetPassword(false);
  };
  const submitChange = async (post) => {
    //call set password with
    props.setLoaderBox(true);
    await postData({ ...post }, "user/reset-password", dispatch, navigation)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          props.setMessage({
            type: 1,
            content: t(response.data.message),
            okay: "Okay",
            onClose: () => {},
            code: 200
          });
          props.setLoaderBox(false);
        } else if (response.status === 201) {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 201 });
          props.setLoaderBox(false);
        } else {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 500 });
          props.setLoaderBox(false);
        }
        setShowResetPassword(false);
        props.setLoaderBox(false);
      })
      .catch((error) => {
        props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        props.setLoaderBox(false);
      });
  };
  const formInput = [
    {
      type: "password",
      placeholder: "currentPassword",
      name: "currentPassword",
      validation: "",
      default: "",
      label: "currentPassword",
      minimum: 6,
      maximum: 16,
      required: true,
    },
    {
      type: "password",
      placeholder: "newPassword",
      name: "newPassword",
      validation: "passwordMatch",
      default: "",
      label: "newPassword",
      minimum: 6,
      maximum: 16,
      required: true,
    },
    {
      type: "password",
      placeholder: "confirmPassword",
      name: "confirmPassword",
      validation: "passwordMatch",
      default: "",
      label: "confirmPassword",
      minimum: 6,
      maximum: 16,
      required: true,
    },
  ];

  const [groups] = useState([
    {
      head: "absences",
      menuItems: [
        {
          _id: "a111",
          label: "holidays",
          sequence: 5,
          icon: "",
          status: true,
          isLink: false,
          element: "holidays",
          path: "/report/holidays",
        },
        {
          _id: "a7",
          label: "Holiday account",
          sequence: 3,
          icon: "",
          status: true,
          isLink: false,
          element: "Holiday account",
          path: "/report/holiday-account",
        },
        {
          _id: "a10",
          label: "Illness",
          sequence: 4,
          icon: "",
          status: true,
          isLink: false,
          element: "Illness",
          path: "/report/illness",
        },
      ],
    },
    {
      head: "Working time account",
      menuItems: [
        {
          _id: "a13",
          label: "Working time account (Minijob)",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Working time account (Minijob)",
          path: "/minijob",
        },
        {
          _id: "a131",
          label: "Working time account (Week)",
          sequence: 2,
          icon: "",
          status: true,
          isLink: false,
          element: "Working time account (Week)",
          path: "/week-time-account",
        },
        {
          _id: "a131a",
          label: "Working time account (Month)",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Working time account (Month)",
          path: "/month-time-account",
        },
        {
          _id: "a131a1",
          label: "Working time account (Year)",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Working time account (Year)",
          path: "/year-time-account",
        },
      ],
    },
    {
      head: "Time recording",
      menuItems: [
        {
          _id: "a13",
          label: "Hours recording",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Hours recording",
          path: "/minijob",
        },
        {
          _id: "a131a",
          label: "Hours recording locations",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Hours recording locations",
          path: "/month-time-account",
        },
        {
          _id: "a131a1",
          label: "Hours recording department",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Hours recording department",
          path: "/year-time-account",
        },
        {
          _id: "a132",
          label: "Hours recording projects",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Hours recording projects",
          path: "/year-time-account",
        },
      ],
    },
    {
      head: "Personnel",
      menuItems: [
        {
          _id: "a21",
          label: "nationalities",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "nationalities",
          path: "/report/nationalities",
        },
        {
          _id: "a22",
          label: "Age distribution",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Working time account (Minijob)",
          path: "/report/minijob",
        },
        {
          _id: "a23",
          label: "Birthdays",
          sequence: 2,
          icon: "",
          status: true,
          isLink: false,
          element: "Birthdays",
          path: "/report/birthday",
        },
        
      ],
    },
    {
      head: "Miscellaneous",
      menuItems: [
        {
          _id: "a21",
          label: "Equipment",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Equipment",
          path: "/report/equipment",
        },
        {
          _id: "a22",
          label: "Documents with expiry date",
          sequence: 2,
          icon: "",
          status: true,
          isLink: false,
          element: "Documents with expiry date",
          path: "/report/documents",
        },
        
      ],
    },
    {
      head: "Customised reports",
      menuItems: [
        {
          _id: "a21",
          label: "Individual time sheets",
          sequence: 1,
          icon: "",
          status: true,
          isLink: false,
          element: "Working time account (Minijob)",
          path: "/minijob",
        },
      ],
    },
  ],)

  return (
    <RowContainer className="list static">
      {!showDetails && <Title className="inner">
        <GetIcon icon={"report"}></GetIcon>
        {t("report")}
      </Title>}
      {!showDetails &&<MenuGroup>
        {groups.map((item) => (
          <MenuGroupItem key={item.head}>
            <Heading>{t(item.head)}</Heading>
            <MenuBox>
              {item.menuItems.map((menu) => (
                <MenuItem
                className="report"
                  key={menu.label}
                  onClick={() => {
                    if (menu.label === "logout") {
                      dispatch(clearLogin());
                    } else if (menu.label === "languageSwitch") {
                      handleLanguageChange();
                    } else if (menu.label === "resetPassword") {
                      setShowResetPassword(true);
                    } else {
                      // setOpenData({ data: { name: menu.label } });
                      // setSelectedMenuItem(menu);
                      // setShowDetails(true);
                      navigation(menu.path)
                    }
                  }}
                >
                  {t(menu.label)}
                </MenuItem>
              ))}
            </MenuBox>
          </MenuGroupItem>
        ))}
      </MenuGroup>}
      {showDetails && (
        <Switch page={selectedMenuItem.element} />
        // <PopupView
        //   // Popup data is a JSX element which is binding to the Popup Data Area like HOC
        //   popupData={selectedMenuItem && <Switch page={selectedMenuItem.element} />}
        //   themeColors={themeColors}
        //   closeModal={() => {
        //     setShowDetails(false);
        //     setSelectedMenuItem(null);
        //   }}
        //   setMessage={props.setMessage}
        //   setLoaderBox={props.setLoaderBox}
        //   itemTitle={{ collection: "", name: "name" }}
        //   openData={openData} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
        //   customClass={"fullpage nopadding"}
        //   menu={selectedMenu}
        // ></PopupView>
      )}
      {showResetPassword && <AutoForm formMode={"single"} enterSubmit={true} useCaptcha={false} formType={"post"} header={t("resetPassword")} formInput={formInput} submitHandler={submitChange} button={t("confirm")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={false}></AutoForm>}
    </RowContainer>
  );
};
// exporting the page with parent container layout..
export default Layout(Report);
